import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Heavyweight Fabrics",
    body: "Ultra-durable 280GSM+ cotton and reinforced stitching designed to withstand high winds and rough rides.",
  },
  {
    n: "02",
    title: "Original Moto Art",
    body: "Screen-printed graphics crafted by riders for street bikes, motocross heads, and custom V-Twin enthusiasts.",
  },
  {
    n: "03",
    title: "Fast Rider Shipping",
    body: "Orders packed and dispatched daily so you can gear up before your next group ride or track day.",
  },
];

export const Manifesto = () => (
  <section id="how" className="relative py-24 md:py-36 bg-[#ECECE8] overflow-hidden" data-testid="manifesto-section">
    <img
      src="/images/motocross.jpg"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute right-[-10%] top-0 h-full w-[55%] object-cover opacity-[0.07]"
    />
    <div className="relative mx-auto max-w-[1600px] px-5 md:px-10">
      <div className="mb-8 md:mb-12 max-w-3xl">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FF4500] mb-4">
          Our Manifesto
        </p>
        <h2 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.85] text-[#111111]">
          Born in the streets. Raised in the dirt.
        </h2>
        <p className="mt-6 text-[#555555] text-base md:text-lg leading-relaxed font-light">
          Whether you're pinning the throttle on a dirt track, tearing down
          urban concrete, or cruising thousands of miles across open highway —
          12 O'Clock Moto Co. represents raw passion on two wheels.
        </p>
      </div>

      <div className="mb-14 md:mb-20">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#555555]">
          The Moto Standard — Built for the Ride
        </p>
      </div>

      <div className="space-y-0">
        {steps.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="group grid md:grid-cols-12 gap-6 md:gap-10 items-center py-10 md:py-14 border-t border-[#111111]/15"
            data-testid={`manifesto-step-${i}`}
          >
            <div className="md:col-span-4">
              <span className="font-display font-black text-[22vw] md:text-[9vw] leading-none text-stroke-ink group-hover:text-stroke transition-all duration-500">
                {s.n}
              </span>
            </div>
            <div className="md:col-span-5">
              <h3 className="font-display font-bold uppercase tracking-tight text-2xl md:text-4xl text-[#111111] group-hover:text-[#FF4500] transition-colors duration-300">
                {s.title}
              </h3>
            </div>
            <div className="md:col-span-3">
              <p className="text-[#555555] text-base leading-relaxed font-light">{s.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
